var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (i18n) {
buf.push("<div id=\"text-input-view\"><div id=\"text-input-container\"><div id=\"text-input-container-top\" class=\"text-input-container block-lg\"><label id=\"text-input-prompt\"></label><label id=\"text-input-count\"><span id=\"text-input-count-current\"></span>&nbsp;/&nbsp;<span id=\"text-input-count-total\"></span></label><div id=\"text-input-dismiss-btn\" class=\"btn btn-solid\">" + (jade.escape(null == (jade_interp = i18n("buttons.done")) ? "" : jade_interp)) + "</div></div><div id=\"text-input-scroll\"><textarea id=\"text-input-area\" class=\"block-lg\"></textarea></div></div></div>");}.call(this,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}